/**
 * Application configuration constants
 * Centralized configuration to eliminate magic numbers and strings
 */

// Table Configuration
export const TABLE_CONFIG = {
  DEFAULT_PAGE_SIZE: 60,
  DEFAULT_PAGE_INDEX: 0,
  SEARCH_DEBOUNCE_MS: 300,
  MAX_CELL_WIDTH: {
    SMALL: 'max-w-xs',
    MEDIUM: 'max-w-sm',
    LARGE: 'max-w-md',
  },
  PAGE_SIZE_OPTIONS: [10, 20, 30, 40, 50, 60],
} as const;

// Time Configuration
export const TIME_CONFIG = {
  MILLISECONDS_PER_MINUTE: 1000 * 60,
  MILLISECONDS_PER_HOUR: 1000 * 60 * 60,
  MILLISECONDS_PER_DAY: 1000 * 60 * 60 * 24,
  DAYS_PER_MONTH: 30,
} as const;

// Task States
export const TASK_STATES = {
  UNASSIGNED: 0,
  ASSIGNED: 1,
  ACTIVE: 2,
  COMPLETED: 3,
} as const;

// Worker Account Status
export const WORKER_ACCOUNT_STATUS = {
  ACCEPTED: 'ACCEPTED',
  INVITED: 'INVITED',
  SUSPENDED: 'SUSPENDED',
} as const;

// Vehicle Types
export const VEHICLE_TYPES = {
  CAR: 'CAR',
  TRUCK: 'TRUCK',
  MOTORCYCLE: 'MOTORCYCLE',
  BICYCLE: 'BICYCLE',
} as const;

// External Service URLs
export const EXTERNAL_URLS = {
  shopifyAdmin: (resource: string, id: string): string | null => {
    const domain = import.meta.env.VITE_SHOP_DOMAIN;
    if (!domain) return null;
    return `https://${domain}/admin/${resource}/${id}`;
  },
  onfleetDashboard: 'https://onfleet.com/dashboard',
  onfleetTask: (onfleetId: string) => `https://onfleet.com/dashboard#/tasks/${onfleetId}`,
  onfleetWorker: (onfleetId: string) =>
    `https://onfleet.com/dashboard#/manage/drivers/${onfleetId}`,
  /** A Google Maps search for one address (#2677). */
  googleMapsSearch: (address: string) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`,
} as const;

// Export Configuration
export const EXPORT_CONFIG = {
  DEFAULT_FORMAT: 'csv',
  FILENAME_TIMESTAMP_FORMAT: 'yyMMdd_HHmmss',
  SUPPORTED_FORMATS: ['csv', 'xlsx', 'json'] as const,
} as const;

// UI Configuration
export const UI_CONFIG = {
  BREAKPOINTS: {
    SM: 640,
    MD: 768,
    LG: 1024,
    XL: 1280,
  },
  ANIMATION: {
    DURATION: {
      FAST: 150,
      NORMAL: 300,
      SLOW: 500,
    },
    EASING: {
      EASE_IN: 'ease-in',
      EASE_OUT: 'ease-out',
      EASE_IN_OUT: 'ease-in-out',
    },
  },
  Z_INDEX: {
    DROPDOWN: 10,
    MODAL: 50,
    TOOLTIP: 100,
  },
} as const;
